import { useEffect, useMemo } from "react"

import { Tabs, Typography } from "antd"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate, useParams } from "react-router"

import TourComponent from "../../Components/Tour"
import { getTourEl } from "../../Utils/utils"
import UserCreators from "../User/reducer"
import AutoRefundPage from "./AutoRefund/AutoRefundPage"
import Enrollments from "./Enrollments"

import "./styles.less"

const pageOptions = [
  { key: "enrollment", label: "Configure" },
  { key: "auto-refund", label: "Auto-refund" }
]

const { Text } = Typography

const ConfigurePage = () => {
  const navigate = useNavigate()
  const { page } = useParams()
  const params = useParams()

  const { businessAccount, nextCreateAccountStep, demoTourStep } = useSelector(
    (state) => state.user
  )
  const { userInfo, isAdmin } = useSelector((state) => state.auth)
  const dispatch = useDispatch()

  const isDemo = isAdmin ? businessAccount?.["is_demo"] : userInfo?.is_demo

  const setDemoTourStep = (step) => {
    dispatch(UserCreators.setDemoTourStep(step))
  }

  useEffect(() => {
    if (userInfo?.current_business_account_id && !nextCreateAccountStep) {
      dispatch(UserCreators.getBusinessAccountRequest(userInfo.current_business_account_id))
    }
  }, [userInfo?.current_business_account_id])

  useEffect(() => {
    document.title = "Configure - Chargeback"
  }, [])

  const steps = useMemo(
    () => [
      {
        title: <Text type="secondary">Tweak your settings and set up rules the way you like.</Text>,
        target: () => getTourEl("configure-nav")
      },
      {
        title: (
          <Text type="secondary">
            Easily switch between pages with customizable auto-refund settings and enrollments to
            keep track of progress.
          </Text>
        ),
        target: () => getTourEl("configure-pages-switch")
      },
      {
        title: (
          <Text type="secondary">Full details of enrollments for monitoring and management</Text>
        ),
        target: () => getTourEl("enrollment"),
        nextButtonProps: {
          onClick: () => {
            navigate("/team")
            setDemoTourStep(5)
          },
          children: <text>Next</text>
        }
      }
    ],
    []
  )

  return (
    <div className="configure-page">
      <div className="configure-tabs">
        <Tabs
          items={pageOptions}
          onChange={(val) => navigate(`/configure/${val}`)}
          activeKey={page}
          data-tour="configure-pages-switch"
        />
      </div>
      {page === "enrollment" && <Enrollments />}
      {page === "auto-refund" && <AutoRefundPage />}
      <TourComponent
        open={demoTourStep === 4}
        steps={steps}
        onClose={() => setDemoTourStep(null)}
      />
    </div>
  )
}

export default ConfigurePage
